import { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import mixpanel from 'mixpanel-browser';

// Redux
import { connect } from 'react-redux';

// Actions
import { toggleSideNav, setPage, add_To_Recent_History, toggleAuthModal } from '../../actions/navActions';

// Layout Wrapper
import Layout from '../../components/layout/Layout';

// Components
import { Button } from '@material-ui/core';
import AboutSection from './AboutSection';
import ActivitySection from './ActivitySection';
import PeopleSection from './PeopleSection';

const AboutPage = ({ 
    nav: { 
        sideNav, 
        website,
        website_loading
    },
    auth,
    setPage, 
    add_To_Recent_History,
    toggleSideNav,
    toggleAuthModal
}) => {

    // State variable to track if Mixpanel event has been sent
    const [sentMixpanel, setSentMixpanel] = useState(false);

    // Check if website is custom url or main website
    const [checked_WebsiteType, setChecked_WebsiteType] = useState(false);

    // Get the current URL and extract the "redirect" parameter
    const url_filter = (window.location.href);
    const url = new URL(url_filter);
    const hostname = window.location.hostname;

    useEffect(() => {

        // Set the current page
        setPage('About Page');
        add_To_Recent_History(url.pathname);  // current url

    }, []);

    // Handles Mixpanel tracking
    const handleMixpanel = () => {
        mixpanel.init(process.env.REACT_APP_MIXPANEL_ID);

        // Track "About Page View" event
        mixpanel.track("About Page View");
    }

    // Checks if the environment is production and Mixpanel tracking hasn't been sent
    if(process.env.NODE_ENV === 'production' && !sentMixpanel && !hostname.includes('xbuysell')) {

        // Call Mixpanel tracking function
        handleMixpanel();

        // Set Mixpanel event as sent
        setSentMixpanel(true);
    }

    // Check if website is custom url or main website (this page is only for custom URLs)
    if(!website_loading && !website && !checked_WebsiteType) {
        window.location.href = '/settings/about';

        setChecked_WebsiteType(true);
    }

    return (
        <Fragment>
            <Layout sideNav={sideNav} handleSlideMenu={toggleSideNav} page="home">

                <div className="feed_headerTabs" style={{borderBottom: '1px solid #e6ecf0'}}>
                    <Link to="/home">
                        <div>
                            <h3>Posts</h3>
                            <div className="block__underline"></div>
                        </div>
                    </Link>
                    <Link to="/photos">
                        <div>
                            <h3>Photos</h3>
                            <div className="block__underline"></div>
                        </div>
                    </Link>
                    <Link to="/about">
                        <div className="active">
                            <h3>About</h3>
                            <div className="block__underline"></div>
                        </div>
                    </Link>
                </div>

                <div style={{borderTop: '1px solid #e6ecf0'}} className="post noHighlight">
                    <AboutSection />
                </div>

                <div style={{borderTop: '1px solid #e6ecf0'}} className="post noHighlight">
                    <ActivitySection />
                </div>

                <div style={{borderTop: '1px solid #e6ecf0'}} className="post noHighlight">
                    <PeopleSection />
                </div>

                {/* Spacer */}
                <div className="no-rides"></div>

            </Layout>

        </Fragment>
    )
}

AboutPage.propTypes = {
    nav: PropTypes.object.isRequired,
    auth: PropTypes.object.isRequired,
    setPage: PropTypes.func.isRequired, // Function prop to set the current page in the navigation
    add_To_Recent_History: PropTypes.func.isRequired,
    toggleSideNav: PropTypes.func.isRequired,
    toggleAuthModal: PropTypes.func.isRequired,
}

const mapStateToProps = state => ({

    // Mapping the states from the Redux store to the below props
    nav: state.nav,
    auth: state.auth
});

export default connect(mapStateToProps, { 

    // Connecting actions to the component
    setPage, 
    add_To_Recent_History,
    toggleSideNav,
    toggleAuthModal
})(AboutPage);